{
  "title": "Connessione della mia applicazione mobile",
  "form": {
    "mobileApp": {
      "label": "Seleziona un’applicazione a scelta per generare il codice QR",
      "placeholder": "Seleziona un’applicazione",
      "validation": {
        "required": "È necessario selezionare un’applicazione mobile"
      }
    },
    "button": {
      "content": "Generazione del codice QR"
    }
  },
  "qrCode": {
    "expirationDate": "Scade il"
  },
  "downloadOfflineAccess": {
    "button": "Scarica la mia configurazione offline"
  },
  "passwordModal": {
    "password": {
      "validation": {
        "pattern": "La password deve contenere almeno 12 caratteri, tra cui lettere maiuscole e minuscole, numeri e caratteri speciali",
        "required": "È necessario inserire una password"
      },
      "label": "Password"
    },
    "title": "Inserire la password fornita dall’applicazione My LogUp"
  }
}
